import { z } from "zod";
import { paginationMetaDtoSchema } from "@nasam/kernel";

const required = z.string().trim().min(1);
const rolesPaginationMetaDtoSchema = paginationMetaDtoSchema
  .transform((meta) => ({
    ...meta,
    firstPageUrl: meta.firstPageUrl.trim(),
    lastPageUrl: meta.lastPageUrl.trim(),
  }))
  .pipe(paginationMetaDtoSchema);

const roleFieldsDtoSchema = z.object({
  id: required,
  nameEn: required,
  nameAr: required,
  isActive: z.boolean(),
  createdAt: required,
  updatedAt: required,
  accountId: required,
});
export const roleDtoSchema = roleFieldsDtoSchema.extend({
  permissions: z.array(required),
});
/**
 * `POST`/`PUT /templates` echo the template back without its `permissions[]` —
 * only the read endpoints embed them — so treat a missing list as empty here.
 */
export const roleMutationDtoSchema = roleFieldsDtoSchema.extend({
  permissions: z.array(required).default([]),
});
export const roleWriteDtoSchema = z.object({
  nameEn: required,
  nameAr: required,
  isActive: z.boolean(),
  permissions: z.array(required),
});
export const rolesListResponseDtoSchema = z.object({
  data: z.array(roleDtoSchema),
  meta: rolesPaginationMetaDtoSchema,
});
export const roleResponseDtoSchema = z.object({ data: roleDtoSchema });
export const roleMutationResponseDtoSchema = z.object({
  data: roleMutationDtoSchema,
});
export const messageResponseDtoSchema = z.object({ message: required });

export type RoleDto = z.infer<typeof roleDtoSchema>;
export type RoleWriteDto = z.infer<typeof roleWriteDtoSchema>;
